import { createAsyncThunk } from '@reduxjs/toolkit';
import * as scoreboardApi from '../../api/financialscoreboardapi';

export const getFinancialScoreboard = createAsyncThunk('getFinancialScoreboard', async (data) => {
    const res = await scoreboardApi.getFinancialScoreboard({ data: data });
    return res.data;
});
